// extracted by mini-css-extract-plugin
module.exports = {"BlogPostHero":"styles_BlogPostHero__iIadP","author":"styles_author__DfIIf","height":"styles_height__OLZez"};